import type { IconNode } from '../types';

/**
 * @name zodiac-scorpio
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTlWNS41YTEgMSAwIDAgMSA1IDBWMTdhMiAyIDAgMCAwIDIgMmg1bC0zLTMiIC8+CiAgPHBhdGggZD0ibTIyIDE5LTMgMyIgLz4KICA8cGF0aCBkPSJNNSAxOVY1LjVhMSAxIDAgMCAxIDUgMCIgLz4KICA8cGF0aCBkPSJNNSA1LjVBMi41IDIuNSAwIDAgMCAyLjUgMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/zodiac-scorpio
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ZodiacScorpio: IconNode = [
  ['path', { d: 'M10 19V5.5a1 1 0 0 1 5 0V17a2 2 0 0 0 2 2h5l-3-3' }],
  ['path', { d: 'm22 19-3 3' }],
  ['path', { d: 'M5 19V5.5a1 1 0 0 1 5 0' }],
  ['path', { d: 'M5 5.5A2.5 2.5 0 0 0 2.5 3' }],
];

export default ZodiacScorpio;
